import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;

amplitude.init(apiKey, null, {
  defaultTracking: true,
  sessionReplay: {
    sessionSampleRate: 1.0, // 100% всех сессий будут записываться
    errorSampleRate: 1.0,   // 100% сессий с ошибкой будут записываться
  },
});

amplitude.add(sessionReplayPlugin());

export default amplitude;